/**
 * Include your custom JavaScript here.
 * Hooks: 'variant:changed', 'product:added', 'cart:refresh' (zie Warehouse-documentatie).
 */

/* TP: winkelwagenpagina bijwerken zonder volledige pagina-herlaad (toegevoegd okt 2026) */
(function () {
  if (window.__tpCartNoReload) return;
  window.__tpCartNoReload = true;
  if (!window.theme || window.theme.pageType !== 'cart') return;
  var busy = false;
  var SEL = '[data-section-type="cart"]';
  function emit(el, name, detail) { el.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} })); }
  function refreshSection() {
    var sec = document.querySelector(SEL);
    if (!sec) return Promise.reject(new Error('no section'));
    var sid = sec.getAttribute('data-section-id');
    var wrap = sec.parentElement;
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(SEL);
        if (!fresh) throw new Error('no fresh section');
        var upId = sid + '-upsell';
        if (sec.querySelector('[data-section-id="' + upId + '"]')) emit(wrap, 'shopify:section:unload', { sectionId: upId });
        emit(wrap, 'shopify:section:unload', { sectionId: sid });
        var node = document.importNode(fresh, true);
        sec.replaceWith(node);
        emit(wrap, 'shopify:section:load', { sectionId: sid });
        var up = node.querySelector('[data-section-id="' + upId + '"]');
        if (up && up.parentElement) emit(up.parentElement, 'shopify:section:load', { sectionId: upId });
        emit(document.documentElement, 'cart:refresh');
      });
  }
  function change(line, quantity) {
    if (busy || !line || isNaN(quantity)) return;
    busy = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    fetch(window.routes.cartChangeUrl + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return refreshSection(); })
      .then(function () { busy = false; document.dispatchEvent(new CustomEvent('theme:loading:end')); })
      .catch(function () { window.location.reload(); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest(SEL + ' [data-action="decrease-quantity"], ' + SEL + ' [data-action="increase-quantity"]');
    if (!t) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (t.disabled || t.hasAttribute('disabled')) return;
    change(t.getAttribute('data-line'), parseInt(t.getAttribute('data-quantity'), 10));
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target.closest && e.target.closest(SEL + ' input.quantity-selector__value[data-line]');
    if (!t) return;
    e.stopImmediatePropagation();
    change(t.getAttribute('data-line'), parseInt(t.value, 10));
  }, true);
})();

/* TP: productpagina met personalisatie-app en offerte-balkje (okt 2026)
   - de app zet het knoppenblok boven kleur/maat; we herstellen de volgorde met CSS
   - volgorde onder de winkelwagenknop: 'Printen/bedruk dit item' (zonder icoon), daaronder languit 'Grotere aantallen nodig? Vraag offerte aan'
   - teksten per taal */
(function () {
  if (!window.theme || window.theme.pageType !== 'product') return;
  var css = 'form.product-form.tp-reorder{display:flex;flex-direction:column}' +
    'form.product-form.tp-reorder>*{order:0}' +
    'form.product-form.tp-reorder>[data-block-type="variant-selector"],form.product-form.tp-reorder>[data-block-type="text"]{order:1}' +
    'form.product-form.tp-reorder>[data-block-type="buy-buttons"]{order:2}' +
    'form.product-form.tp-reorder>[data-block-type="product-meta"]~[data-block-type="@app"],form.product-form.tp-reorder>[data-block-type="description"]{order:3}' +
    'form.product-form.tp-reorder>.product-info__block-item--tp-usp{order:4}' +
    '.product-form__buy-buttons .product-personalizer{display:block;width:100% !important;max-width:100% !important;margin:12px 0 0 !important;padding:0 !important}' +
    '.product-form__buy-buttons .product-personalizer .pplr-c-button{display:flex !important;align-items:center;justify-content:center;width:100% !important;height:48px !important;min-height:48px !important;margin:0 !important;padding:0 16px !important;background:#fff !important;color:#1d3b73 !important;border:1.5px solid #1d3b73 !important;border-radius:2px !important;box-shadow:none !important;font-size:14px !important;font-weight:600 !important;line-height:1.2 !important;text-transform:none !important;letter-spacing:0 !important}' +
    '.product-form__buy-buttons .product-personalizer .pplr-c-button:hover{background:#f1f5fb !important}' +
    '.product-form__buy-buttons .pd-quote-bar{width:100% !important;margin:12px 0 0 !important;height:48px !important}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var PRINT = { nl: 'Printen/bedruk dit item', de: 'Dieses Produkt bedrucken', en: 'Print this item', fr: 'Imprimer cet article', es: 'Imprimir este artículo', it: 'Stampa questo articolo', pt: 'Imprimir este artigo', da: 'Tryk på denne vare', el: 'Εκτύπωση αυτού του προϊόντος' };
  var QUOTE = { nl: 'Grotere aantallen nodig? Vraag offerte aan', de: 'Größere Mengen nötig? Angebot anfragen', en: 'Need larger quantities? Request a quote', fr: 'Besoin de grandes quantités ? Demandez un devis', es: '¿Necesitas grandes cantidades? Solicita presupuesto', it: 'Servono grandi quantità? Richiedi un preventivo', pt: 'Precisa de grandes quantidades? Peça orçamento', da: 'Brug for større mængder? Anmod om tilbud', el: 'Χρειάζεστε μεγαλύτερες ποσότητες; Ζητήστε προσφορά' };
  var printLabel = PRINT[lang] || PRINT.nl, quoteLabel = QUOTE[lang] || QUOTE.nl;
  function apply() {
    var bb = document.querySelector('.product-form__buy-buttons');
    if (!bb) return;
    var pp = document.querySelector('.product-personalizer');
    var bar = document.querySelector('.pd-quote-bar');
    if (bar) {
      var sp = bar.querySelector('span');
      if (sp && sp.textContent !== quoteLabel) sp.textContent = quoteLabel;
    }
    if (pp) {
      var form = document.querySelector('form.product-form');
      if (form && !form.classList.contains('tp-reorder')) form.classList.add('tp-reorder');
      pp.querySelectorAll('button, a').forEach(function (b) {
        var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT);
        var n; while ((n = w.nextNode())) { if (/personali/i.test(n.nodeValue)) n.nodeValue = printLabel; }
      });
    }
    /* volgorde onderin het knoppenblok: [personalisatie] -> [offerte-balkje], beide als laatste */
    var want = [pp, bar].filter(Boolean);
    var ok = want.length && want.every(function (el, i) { return el.parentElement === bb && bb.children[bb.children.length - want.length + i] === el; });
    if (want.length && !ok) want.forEach(function (el) { bb.appendChild(el); });
  }
  var obs = new MutationObserver(function () { apply(); });
  function start() { apply(); obs.observe(document.body, { childList: true, subtree: true, characterData: true }); setTimeout(function () { obs.disconnect(); }, 20000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* TP: minimumorderbedrag €30 incl. btw over de niet-outlet-artikelen (outlet is vrijgesteld) */
(function () {
  if (window.__tpMinOrder) return; window.__tpMinOrder = true;
  var MIN = 3000; // in centen, incl. btw (winkelwagenbedragen zijn incl. btw)
  var lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var T = {
    nl: ['Het minimale bestelbedrag is {min} (incl. btw).', 'Voeg nog {rest} toe om af te rekenen.'],
    en: ['The minimum order value is {min} (incl. VAT).', 'Add {rest} more to check out.'],
    de: ['Der Mindestbestellwert beträgt {min} (inkl. MwSt.).', 'Fügen Sie noch {rest} hinzu, um zur Kasse zu gehen.'],
    fr: ['Le montant minimum de commande est de {min} (TTC).', 'Ajoutez encore {rest} pour passer commande.'],
    es: ['El pedido mínimo es de {min} (IVA incluido).', 'Añade {rest} más para finalizar la compra.'],
    it: ["L'ordine minimo è di {min} (IVA inclusa).", 'Aggiungi ancora {rest} per procedere al pagamento.'],
    pt: ['O valor mínimo de encomenda é {min} (com IVA).', 'Adicione mais {rest} para finalizar a compra.'],
    da: ['Minimumsordren er {min} (inkl. moms).', 'Tilføj {rest} mere for at gå til kassen.'],
    el: ['Η ελάχιστη αξία παραγγελίας είναι {min} (με ΦΠΑ).', 'Προσθέστε ακόμη {rest} για να ολοκληρώσετε την αγορά.']
  };
  var txt = T[lang] || T.nl;
  function money(c) { try { return new Intl.NumberFormat(lang === 'el' ? 'el-GR' : (document.documentElement.lang || 'nl'), { style: 'currency', currency: 'EUR' }).format(c / 100); } catch (e) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); } }
  var css = document.createElement('style');
  css.textContent = '.tp-minorder{margin:10px 0;padding:10px 12px;border-radius:6px;background:#fff4e5;border:1px solid #f0b35b;color:#7a4b00;font-size:14px;line-height:1.4;text-align:left}' +
    '.tp-minorder-blocked{opacity:.45!important;pointer-events:none!important;cursor:not-allowed!important}' +
    'html.tp-below-min .shopify-payment-button, html.tp-below-min .additional-checkout-buttons, html.tp-below-min [data-shopify="payment-button"], html.tp-below-min shopify-accelerated-checkout, html.tp-below-min shopify-accelerated-checkout-cart{display:none!important}';
  document.head.appendChild(css);
  var subtotal = null;
  function checkoutEls() {
    return Array.prototype.slice.call(document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"], form[action$="/checkout"] [type="submit"]'));
  }
  function apply() {
    if (subtotal === null) return;
    var below = subtotal > 0 && subtotal < MIN;
    document.documentElement.classList.toggle('tp-below-min', below);
    var msg = txt[0].replace('{min}', money(MIN)) + ' ' + txt[1].replace('{rest}', money(MIN - subtotal));
    checkoutEls().forEach(function (el) {
      el.classList.toggle('tp-minorder-blocked', below);
      if (el.tagName !== 'A') el.disabled = below;
      var host = el.parentNode; if (!host) return;
      var note = host.querySelector(':scope > .tp-minorder');
      if (below) {
        if (!note) { note = document.createElement('p'); note.className = 'tp-minorder'; host.insertBefore(note, el); }
        if (note.textContent !== msg) note.textContent = msg;
      } else if (note) { note.remove(); }
    });
  }
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      // outlet-artikelen (SKU eindigt op OUTL) zijn vrijgesteld en tellen niet mee
      subtotal = (c.items || []).reduce(function (s, it) { return /OUTL$/i.test(it.sku || '') ? s : s + (it.final_line_price != null ? it.final_line_price : it.line_price); }, 0); apply();
    }).catch(function () {});
  }
  // blokkeer ook klikken/submits als de knop toch actief is geworden
  document.addEventListener('click', function (e) {
    if (!document.documentElement.classList.contains('tp-below-min')) return;
    var t = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (t) { e.preventDefault(); e.stopPropagation(); apply(); }
  }, true);
  document.addEventListener('submit', function (e) {
    if (!document.documentElement.classList.contains('tp-below-min')) return;
    var f = e.target, act = (f.getAttribute('action') || '');
    var sub = e.submitter;
    if (/\/checkout/.test(act) || (sub && sub.name === 'checkout')) { e.preventDefault(); e.stopPropagation(); apply(); }
  }, true);
  ['cart:updated', 'cart:refresh', 'product:added', 'variant:added', 'cart:rerendered'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refresh, 300); }); });
  var of = window.fetch;
  window.fetch = function () {
    var p = of.apply(this, arguments);
    try { var u = String(arguments[0] && arguments[0].url || arguments[0]); if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refresh, 300); }); } catch (e) {}
    return p;
  };
  var tpQ = false; new MutationObserver(function () { if (subtotal === null || tpQ) return; tpQ = true; requestAnimationFrame(function () { tpQ = false; apply(); }); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();

/* TP: "Kies opties"/snel-toevoegen in productoverzichten verbergen op mobiel (werkte niet goed) */
(function () {
  if (window.__tpHideQuickBuy) return; window.__tpHideQuickBuy = true;
  var s = document.createElement('style');
  s.textContent = '@media screen and (max-width: 999px){ .product-item .product-item__action-list, .product-item .product-item__action-button { display: none !important; } }';
  document.head.appendChild(s);
})();
